import { getClient } from '@lib/sanity'
import { loadTranslation } from '@lib/i18n'
import { groq } from 'next-sanity'
import TeamIndex from 'components/TeamIndex'

const teamMembersQuery = groq`*[_type == "teamMember"] | order(order asc, lower(name) asc){..., teamGroup[]}`
const teamGroupQuery = groq`*[_type == "teamGroup"] | order(order asc)`

export const getStaticProps = async ({ locale, params, preview = false }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV === 'production'
  )
  const items = await getClient(preview).fetch(teamMembersQuery, {
    locale,
  })
  const groups = await getClient(preview).fetch(teamGroupQuery, { locale })

  return {
    props: {
      translation,
      items,
      groups,
      preview,
    },
    revalidate: 60 * 5, // Every five mins
  }
}

export default TeamIndex
